


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Drift from 'drift-zoom';
import { ProductImageDto } from '@eurogast/hub-client-typescript';

@Component
export default class ZoomableImage extends Vue {

  @Prop({ required: true })
  public image: ProductImageDto;

  @Prop({ required: true })
  public isCurrent: boolean;

  @Prop({ required: true })
  public show3dImage: boolean;

  @Prop({ required: false, default: false })
  public inline: boolean;
  @Prop({ required: false, default: null })
  public namespace: string;

  @Prop({ required: false, default: false })
  public touch: string;


  @Prop({ required: false })
  public zoomFactor: number;

  private drift: Drift;


  private customStyleSheet: CSSStyleSheet;
  private customStyle: HTMLStyleElement;

  @Watch('image')
  public mountDrift() {
    const image = this.$refs.baseImage as HTMLImageElement;
    this.unmountStyleSheet();
    if (this.drift) {
      this.drift.destroy();
    }
    const options = {
      paneContainer: this.$refs.paneContainer,
      hoverBoundingBox: true,
      handleTouch: this.touch,
      inlinePane: this.inline,
      containInline: true,
      namespace: this.namespace,
      inlineOffsetX: 0,
      inlineOffsetY: 0,
      showWhitespaceAtEdges: false,
      onShow: null,
      zoomFactor: this.zoomFactor
    };
    this.drift = new Drift(image, options);


    this.customStyle = document.createElement('style');
    // WebKit hack :(
    this.customStyle.appendChild(document.createTextNode(''));
    document.head.appendChild(this.customStyle);
    this.customStyleSheet = this.customStyle.sheet as CSSStyleSheet;

    this.customStyleSheet.insertRule(
      `.product-zoom-inline {
        height: ${image.clientHeight}px;
        width: ${image.clientWidth}px;
    }`, 0);
  }


  public previousImage() {
    this.$emit('previous-image');
  }

  public nextImage() {
    this.$emit('next-image');
  }


  private beforeDestroy() {
    this.unmountStyleSheet();
    this.drift.destroy();
  }


  private destroyed() {
    let elementsToRemove = document.getElementsByClassName('product-zoom-open');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elementsToRemove.length; i++) {
      document.body.removeChild(elementsToRemove[i]);
    }

    elementsToRemove = document.getElementsByClassName('product-zoom-inline');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < elementsToRemove.length; i++) {
      document.body.removeChild(elementsToRemove[i]);
    }
  }


  private unmountStyleSheet() {
    if (this.customStyle) {
      this.customStyleSheet.deleteRule(0);
      document.head.removeChild(this.customStyle);
    }
  }
}
